// extracted by mini-css-extract-plugin
export default {"cancle":"buttonStyles_cancle__2PAiF","sucess":"buttonStyles_sucess__wOwuV"};